<body class="ltr main-body leftmenu">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="StdAtdSetting">
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <div class="col-lg-12 col-md-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="col-md-12 prpl">
                                        <div class=" d-flex align-items-center">
                                            <img alt="Logo" src="../../assets/img/attendance.png" class="mh-45px pb-2">
                                            <p class="mb-1">
                                                <span class="main-content-label"><b>Subject Attendance Master</b></span><br>
                                                <span class="text-muted card-sub-title mb-0">List Of Subject
                                                    Attendance Master</span>
                                            </p>
                                        </div>
                                    </div>
                                    <hr class="mt-2">
                                    <div class="row clearfix mt-2">
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Session</mat-label>
                                                        <mat-select required #select232 placeholder="Session" class="colorblack"
                                                            formControlName="SessionId" (selectionChange)="onSessionChange($event.value)">
                                                            <mat-select-filter *ngIf="select232.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                [array]="sessionList"
                                                                (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of SessionFilterList"
                                                                [value]="item.SnNo"  (click)="SetSession(item.SnNo)">
                                                                {{item.SnName}}
                                                            </mat-option>
                                                        </mat-select>
                                                         <mat-error class="margin_tp"
                                                                *ngIf="StdAtdSetting.controls['SessionId']?.touched && StdAtdSetting.controls['SessionId'].errors?.required">
                                                                Mandatory
                                                         </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                         <div class="col-sm-3">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>{{'header.faculty-data.titleList.Faculty'| translate }}</mat-label>
                                            <mat-select required #select33 
                                                placeholder="CoFcCode"
                                                class="colorblack" 
                                                formControlName="CoFcCode" 
                                                [disabled]="!StdAtdSetting.get('SessionId').value"
                                                (selectionChange)="onFacultyChange($event.value)">
                                            <mat-select-filter *ngIf="select33.focused" 
                                                [placeholder]="'Filter'"
                                                [displayMember]="'FcDesc'" 
                                                [array]="fcCodeList"
                                                (filteredReturn)="filteredListFcCode =$event">
                                            </mat-select-filter>
                                            <mat-option *ngFor="let item of filteredListFcCode" 
                                                [value]="item.FcCode">
                                                {{item.FcCode}} - {{item.FcDesc}}
                                            </mat-option>
                                            </mat-select>
                                            <mat-error class="margin_tp"
                                                *ngIf="StdAtdSetting.controls['CoFcCode']?.touched && StdAtdSetting.controls['CoFcCode'].errors?.required">
                                                Mandatory
                                            </mat-error>
                                            </mat-form-field>
                                        </div>
                                        
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Course</mat-label>
                                                        <mat-select required #select23 placeholder="Course" class="colorblack"
                                                            formControlName="CoCode" [disabled]="!StdAtdSetting.get('CoFcCode').value" (selectionChange)="onCourseChange($event.value)">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                                [array]="CourseList"
                                                                (filteredReturn)="filteredListCourse =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListCourse"
                                                                [value]="item.CoCode">
                                                                {{item.CoCode}} - {{item.CoName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-sm-3">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>College</mat-label>
                                                    <mat-select multiple
                                                        formControlName="CgCode"
                                                        placeholder="College"
                                                        [disabled]="!StdAtdSetting.get('CoCode').value"
                                                        (selectionChange)="onCollegeSelect($event)">
                                                    <mat-option 
                                                        [value]="'selectAll'"
                                                        (click)="onSelectAllClick()"
                                                        [selected]="isAllCollegesSelected()">
                                                        Select All
                                                    </mat-option>
                                                    <mat-option *ngFor="let item of filteredCollegeList"
                                                        [value]="item.CgCode"
                                                        [selected]="selectedColleges.includes(item.CgCode)">
                                                        {{item.CgCode}} - {{item.CgName}}
                                                    </mat-option>
                                                    </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div> -->

                                        <div class="col-sm-3">
                                        <div class="form-group">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>College</mat-label>
                                                <mat-select multiple
                                                    formControlName="CgCode"
                                                    placeholder="College"
                                                    [disabled]="!StdAtdSetting.get('CoCode').value"
                                                    (selectionChange)="onCollegeSelect($event)">
                                                    <mat-option 
                                                        [value]="'selectAll'"
                                                        (click)="onSelectAllClick()"
                                                        [selected]="isAllCollegesSelected()">
                                                        Select All
                                                    </mat-option>
                                                    <mat-option *ngFor="let item of filteredCollegeList"
                                                        [value]="item.CgCode"
                                                        [disabled]="true"
                                                        [selected]="selectedColleges.includes(item.CgCode)">
                                                        {{item.CgCode}} - {{item.CgName}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                            
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Exam</mat-label>
                                                        <mat-select required #select234 placeholder="Exam" class="colorblack"
                                                            formControlName="EmId"
                                                            [disabled]="!StdAtdSetting.get('CgCode').value?.length"
                                                            (selectionChange)="onExamChange($event.value)">
                                                            <mat-select-filter *ngIf="select234.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                                [array]="ExamList"
                                                                (filteredReturn)="filteredListExam =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListExam"
                                                                [value]="item.EmId" (click)="getExmSub(item)">
                                                                {{item.EmCode}} - {{item.EmName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3" *ngIf="BranchShow">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Branch</mat-label>
                                                        <mat-select required #select235 placeholder="Branch" class="colorblack"
                                                            formControlName="StrId">
                                                            <mat-select-filter *ngIf="select235.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'StrName'"
                                                                [array]="BranchList"
                                                                (filteredReturn)="filteredListBranch =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListBranch"
                                                                [value]="item.StrId" (click)="getBrSub(item.StrId)">
                                                                {{item.StrCode}} - {{item.StrName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                           Subject
                                                        </mat-label>
                                                        <mat-select #select23 placeholder="CoCode"
                                                            formControlName="EsParentId" 
                                                            [disabled]="!StdAtdSetting.get('EmId').value"
                                                            (selectionChange)="ShowTable()">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EsName'"
                                                                [array]="subjectList"
                                                                (filteredReturn)="filteredsubjectList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredsubjectList"
                                                                [value]="item.EsId" (click)="ShowTable()">
                                                             {{item.EsCode}}-{{item.EsName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        

                                        <div *ngIf="Table" class="table-responsive sccc mt-4">
                                            <div class="container">
                                                <table  class="table  table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th class="f600" width="8%">
                                                                Sr.No
                                                            </th>
                                                            <th class="f600" *ngIf="showCgName">
                                                                College Name
                                                            </th>
                                                            <th class="f600" width="8%">
                                                                Part Code
                                                            </th>
                                                            <th class="f600" width="20%">
                                                                Part Name
                                                            </th>
                                                            <th class="f600">
                                                                Attendance
                                                            </th>
                                                            <th hidden>
                                                                EsId
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data" formArrayName="StuArray">
                                                        <tr  *ngFor="let markData of getStuArrayControls(); let i = index" 
                                                        [formGroupName]="i">
                                                        <td>
                                                            <input readonly class="tab2 form-control input-sm"
                                                            formControlName="SrNo">
                                                        </td>
                                                        <td *ngIf="showCgName">
                                                            <input readonly class="tab2 form-control input-sm"
                                                            formControlName="CgName">
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2 form-control input-sm"
                                                                formControlName="EsCode">
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2 form-control input-sm"
                                                                formControlName="EsName">
                                                            </td>
                                                            <td>
                                                                <input class="tab3 form-control text-center" (change)="onAttendanceChange(i)" formControlName="Attendance" maxlength="3"
                                                                    (keyup)="onInputChange2($event,i)">
                                                                    <mat-error class="margin_tp mrgtp"
                                                                        *ngIf="markData.controls.Attendance.touched && markData.controls.Attendance.errors?.NonNumericError">
                                                                        Invalid
                                                                    </mat-error>
                                                                    <mat-error class="margin_tp mrgtp"
                                                                        *ngIf="markData.controls.Attendance.touched && markData.controls.Attendance.errors?.PercentError">
                                                                        Enter Less Than 100%
                                                                    </mat-error>
                                                                    <mat-error class="margin_tp mrgtp"
                                                                    *ngIf="markData.controls.Attendance.touched && markData.controls.Attendance.errors?.required">
                                                                    Mandatory
                                                                </mat-error>
                                                            </td>
                                                            <td hidden>
                                                                <input id="getid(markData)" readonly class="tab2 form-control input-sm"
                                                                formControlName="EsId">
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                           
                                        </div>
                                        <div class="col-sm-12 mb-3">
                                           
                                            <button  type="button"
                                                class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                                (click)="Save()" *ngIf="SaveBtn && AtdSettingCreate" [disabled]="saveDisable">
                                                <!-- && AtdSettingCreate -->
                                                <span style="display: contents; align-items: center;">
                                                    <img width="15vh" src="../../assets/img/save.gif"
                                                        style="margin-right: 7px;">
                                                        Save
                                                </span>
                                            </button>
                                            <!-- && AtdSettingUpdate -->
                                            <button *ngIf="UpdateBtn && AtdSettingUpdate" type="button"
                                            
                                            class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                            (click)="update()" [disabled]="updateDisable">
                                            <span style="display: contents; align-items: center;">
                                                <img width="15vh" src="../../assets/img/edit1.gif"
                                                    style="margin-right: 7px;">
                                                    Update
                                            </span>
                                        </button>
                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>